export default {
    "container": {
        "w-full": true
    },
    "table-container": {
        "w-full overflow-x-auto rounded-t": true
    },
    "table": {
        "min-w-full": true,
    },
    "t-head": {
        "bg-gray-100": true,
        "border": true,
    },
    "t-body": {
        "bg-white border-r border-l border-b": true,
    },
    "t-body-tr": {
        "bg-white even:bg-gray-100": true,
    },
    "td": {
        "px-4 py-3 whitespace-no-wrap border-b border-gray-200": true,
    },
    "th": {
        "p-4 text-xs whitespace-no-wrap hover:cursor-pointer text-left": true,
    }
};
